import {
  QUERY_ASISTENCIAS_EN_RANGO,
  QUERY_OBTENER_ASISTENCIA_POR_ID,
  QUERY_OBTENER_LISTAS_ASISTENCIAS_PROYECTADAS,
  useListarAsistenciasEnRango,
} from "../../services/asistenciaServicios";
import ServerErrorModal from "../organisms/ServerErrorModal";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  reagendarGuarderia,
  useBuscarAgendamientoDeReservaGuarderia,
} from "../../services/agendamientosGuarderiaServicios";
import ReagendamientoModal from "./ReagendamientoModal";
import { haceUnAno, stringADate, unAnoMas } from "../../utils/dateUtils";

function ReagendamientoGuarderiaModal({
  itemAsistencia,
  onClose,
  fecha,
  idReserva,
  fechasOcupadasAdicionales,
}: {
  itemAsistencia: {
    idMascota: string;
    nombreMascota: string;
    nombrePropietario: string;
  };
  fecha: Date;
  onClose: () => void;
  idReserva: string;
  fechasOcupadasAdicionales?: Date[];
}) {
  const queryClient = useQueryClient();

  const inicioRangoAsistencias = haceUnAno();
  const finRangoAsistencias = unAnoMas();

  const {
    data: agendamientoGuarderia,
    isLoading: isLoadingAgendamientoGuarderia,
    isError: isErrorAgendamientoGuarderia,
  } = useBuscarAgendamientoDeReservaGuarderia(idReserva, true);

  const {
    data: asistencias,
    isLoading: isLoadingAsistencias,
    isError: isErrorAsistencias,
  } = useListarAsistenciasEnRango(
    inicioRangoAsistencias,
    finRangoAsistencias,
    itemAsistencia.idMascota
  );

  const mutacionReagendarGuarderia = useMutation(reagendarGuarderia, {
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_ASISTENCIAS_EN_RANGO]);
      queryClient.invalidateQueries([
        QUERY_OBTENER_LISTAS_ASISTENCIAS_PROYECTADAS,
      ]);
      queryClient.invalidateQueries({
        queryKey: [QUERY_OBTENER_ASISTENCIA_POR_ID],
        refetchType: "none",
      });
      onClose();
    },
  });

  const onGuardarClick = (fechasReemplazadas: Map<string, string>) => {
    if (!agendamientoGuarderia) return;
    mutacionReagendarGuarderia.mutate({
      idAgendamiento: agendamientoGuarderia.id,
      request: {
        fechas: Object.fromEntries(fechasReemplazadas),
        idReservaGuarderia: idReserva,
      },
    });
  };

  const isError =
    isErrorAsistencias ||
    isErrorAgendamientoGuarderia ||
    mutacionReagendarGuarderia.isError;

  const fetchIsLoading =
    isLoadingAgendamientoGuarderia || isLoadingAsistencias;

  const fechasOcupadas = (asistencias || []).map((asistencia) =>
    stringADate(asistencia.fecha)
  );

  if (isError) {
    return <ServerErrorModal onClose={onClose} />;
  }

  return (
    <ReagendamientoModal
      fechasIsLoading={fetchIsLoading}
      guardando={mutacionReagendarGuarderia.isLoading}
      onGuardar={onGuardarClick}
      onClose={onClose}
      fechasOcupadas={fechasOcupadas.concat(fechasOcupadasAdicionales || [])}
      fecha={fecha}
      itemAsistencia={itemAsistencia}
      maxDate={stringADate(finRangoAsistencias)}
    />
  );
}

export default ReagendamientoGuarderiaModal;
